export type Modalities = {
  id: string;
  modalities: Modality[];
};

export type Modality = {
  id: string;
  name: string;
  modality: ModalityEnum;
  order: number;
};

export type UserModality = {
  id: string;
  name: string;
  modality: ModalityEnum;
  modalityId: string;
  userId: string;
  order: number;
};

export const enum ModalityEnum {
  individual = 'individual',
  couples = 'couples',
  group = 'group',
  families = 'families',
}